import { render, staticRenderFns } from "./PostCalendar.vue?vue&type=template&id=5448f9ca&scoped=true&"
import script from "./PostCalendar.vue?vue&type=script&lang=js&"
export * from "./PostCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PostCalendar.vue?vue&type=style&index=0&id=5448f9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448f9ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
